import React from 'react'
import Navega from '../componentes/Nav'
import HeroSection from '../componentes/HeroSection'
import AboutIntro from '../componentes/AboutIntro'
import MissionVision from '../componentes/MissionVision'
import CorporateValues from '../componentes/CorporateValues'
import Footer from '../componentes/footer'
import '../estilos/QuieneSomos.css'

function Quiene_Somos() {
  return (
    <>
      <Navega />
      <HeroSection />
      <AboutIntro />
      <MissionVision />
      <CorporateValues />
      <Footer />
    </>
  )
}

export default Quiene_Somos
